/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ profile: NonNullable<unknown> }} Private_Models_Checklist_ProfileInputs */



/**
* | output |
* | --- |
* | "Detected server: {profile}" |
*
* @param {Private_Models_Checklist_ProfileInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_checklist_profile = /** @type {((inputs: Private_Models_Checklist_ProfileInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Checklist_ProfileInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Erkannter Server: ${i?.profile}`)
	return /** @type {LocalizedString} */ (`Detected server: ${i?.profile}`)
});